import { render, staticRenderFns } from "./EmployeeApp.vue?vue&type=template&id=ab0a134c&scoped=true"
import script from "./EmployeeApp.vue?vue&type=script&lang=js"
export * from "./EmployeeApp.vue?vue&type=script&lang=js"
import style0 from "./EmployeeApp.vue?vue&type=style&index=0&id=ab0a134c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0a134c",
  null
  
)

export default component.exports